import tippy from "tippy.js";

export function tippy_action(node, config) {
	config.theme = "tastummy";
	let tooltip = tippy(node, config);
	return {
		destroy: () => {
			tooltip.destroy();
		},
		update: (newParams) => {
			tooltip.setProps(newParams);
		},
	};
}